import { getAmplitudeInstance } from '../amplitudeHelpers';

type logReviewFilterButtonClickedParams = {
  trail_id: number;
};

/**
 * Trigger when a user clicks on the filter button in reviews.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id
 */
const logReviewFilterButtonClicked = ({ trail_id }: logReviewFilterButtonClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('review filter button clicked', { 'trail id': trail_id }, callback);
};

export default logReviewFilterButtonClicked;
